import React, {useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { getMissions } from "../../api/Api";
import { Difficulty } from "../../shared/Difficulty";
import PageContainer from '../../shared/PageContainer';
import GlowCard from '../../shared/GlowCard';
import StatusBadge from '../../shared/StatusBadge';
import CyberpunkTitle from '../../shared/CyberpunkTitle';
import { useColors } from '../../theme/ColorModeContext';

interface PropsMissions {
    token: string;
}

interface Mission {
    id: string;
    name: string;
    app: string;
    difficulty: number;
    solved: boolean;
    points: number;
}

const Missions = (props: PropsMissions) => {
    const colors = useColors();
    const token = props.token;
    const [missions, setMissions] = useState<Mission[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await getMissions(token);
            if(data) {
                setMissions(data.missions);
            }
        }
        fetchData();
    }, []);

    return (
        <PageContainer>
            <CyberpunkTitle
                title="Season 1"
                badge="ACTIVE"
                subtitle="ENDS JUL 31, 2026"
                mb="32px"
            />
            <Grid container spacing={3}>
                {missions.map((mission, index) => (
                    <Grid item key={index} xs={12} sm={6} md={4} lg={2.4}>
                        <Link to={`/missions/${mission.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                            <GlowCard>
                                <Box sx={{ position: 'relative' }}>
                                    <Box sx={{
                                        backgroundImage: `url("/images/missions/${mission.app}.png")`,
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        paddingTop: '100%',
                                        borderRadius: '12px 12px 0 0',
                                        position: 'relative',
                                    }}>
                                        {/* Gradient overlay */}
                                        <Box sx={{
                                            position: 'absolute',
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            height: '50%',
                                            background: 'linear-gradient(180deg, transparent 0%, rgba(15, 20, 32, 0.9) 100%)',
                                        }} />

                                        {/* Points badge */}
                                        <Box sx={{
                                            position: 'absolute',
                                            top: '12px',
                                            right: '12px',
                                            backgroundColor: 'rgba(10, 14, 23, 0.7)',
                                            backdropFilter: 'blur(8px)',
                                            border: `1px solid ${colors.border.default}`,
                                            borderRadius: '6px',
                                            padding: '4px 10px',
                                        }}>
                                            <Typography variant="body2" sx={{
                                                fontFamily: '"Orbitron", sans-serif',
                                                fontWeight: 600,
                                                color: colors.accent.cyan,
                                            }}>
                                                {mission.points} pts
                                            </Typography>
                                        </Box>

                                        {/* Solved indicator */}
                                        {mission.solved && (
                                            <Box sx={{
                                                position: 'absolute',
                                                bottom: '12px',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                            }}>
                                                <StatusBadge solved={true} size="medium" />
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                                <Box sx={{ textAlign: 'center', padding: '16px' }}>
                                    <Typography variant="h6" sx={{
                                        fontFamily: '"Orbitron", sans-serif',
                                        fontWeight: 600,
                                        fontSize: '0.95rem',
                                        marginBottom: '8px',
                                    }}>
                                        {mission.name}
                                    </Typography>
                                    <Difficulty level={mission.difficulty} />
                                </Box>
                            </GlowCard>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </PageContainer>
    );
}

export default Missions;
